import React from 'react'

function Ad() {
    return (
        <div className='flex ai ad-container'>
     <div className='ad-div'>
<p className='ads'>
    ADS
</p>
</div>
        </div>
   
    )
}

export default Ad
